import { createContext } from 'react'

const ReactReduxFirebaseContext = createContext('ReactReduxFirebase')

export default ReactReduxFirebaseContext
